import {ImageField} from 'react-admin';

const ImageFieldMod = props => {
    return (<ImageField {...props} />);
};

export default ImageFieldMod;